// @ts-nocheck
import {ref, Ref} from "vue"

const $auth: Ref<any | null> = ref(null)

export default $auth